/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useDispatch } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { postCartItems } from "./CartSlice";
import { deleteCartItem } from "./deleteCartItemSlice";

function AddRemoveDuplicate(props) {
  const dispatch = useDispatch();
  const { itemQuantity, item } = props;
  const handleAdd = () => {
    console.debug("adding item", item);
    dispatch(postCartItems(item));
  };

  const handleRemove = () => {
    /* execute to delete an item from cart */
    console.debug("remove item", item);
    dispatch(deleteCartItem(item));
  };
  return (
    <ButtonGroup
      size='small'
      aria-label='small outlined button group'
      sx={{ boxShadow: " 0px 2px 4px rgba(0, 0, 0, 0.4)", marginTop: 1 }}
    >
      <Button onClick={handleAdd} startIcon={<AddIcon />} />
      <Button disabled>{itemQuantity}</Button>
      <Button onClick={handleRemove} startIcon={<RemoveIcon />} />
    </ButtonGroup>
  );
}

AddRemoveDuplicate.propTypes = {
  itemQuantity: PropTypes.number,
  item: PropTypes.shape({
    image_loc: PropTypes.string.isRequired,
    item_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    toppings: PropTypes.instanceOf(Array),
  }).isRequired,
};

AddRemoveDuplicate.defaultProps = {
  itemQuantity: 0,
};

export default AddRemoveDuplicate;
